<template>
  <vs-popup
    class="holamundo items-center"
    :title="$t('Progress_measure')"
    :active.sync="popupResultActivo"
    :button-close-hidden="true"
  >
    <div>
      <div class="mb-base">
        <h6 class="text-center">
          {{ $t("competencyProgress.result.r1") }}
        </h6>
      </div>
      <div class="mt-2 mb-2">
        <ProgressMeasureChart :progress="progress" :practice="practice" :relevancy="relevancy" />
      </div>
      <div class="mt-2 mb-base">
        <p class="text-center">
          {{ $t("competencyProgress.result.r2") }}
        </p>
      </div>
      <div class="mb-base">
        <p class="font-bold text-center" @click="externalFeedback" style="cursor: pointer;">
          {{ $t("competencyProgress.result.r3") }}
        </p>
      </div>
      <div>
        <vs-button
          size="small"
          @click="closeResultPopup"
        >{{ $t("competencyProgress.result.r4") }}</vs-button
        >
        <!--<p class="font-bold text-center" @click="closeResultPopup">
          Close
        </p>-->
      </div>
    </div>
  </vs-popup>
</template>

<script>
import ProgressMeasureChart from "../../components/ProgressMeasureChart";
export default {
  name: "Result",
  props: ["progress", "practice", "relevancy"],
  components: { ProgressMeasureChart },
  data() {
    return {
      popupResultActivo: true
    };
  },
  methods: {
    closeResultPopup(){
      this.popupResultActivo = false
      this.$nextTick().then(() => {
        this.$router.push({name: "skill-details", params: { traineeCompetenciesId: this.$route.params.traineeCompetenciesId }})
      })
    },
    externalFeedback() {
      this.popupResultActivo = false
      this.$nextTick().then(() => {
        this.$router.push({name: "endorsement-invite", params: { traineeCompetenciesId: this.$route.params.traineeCompetenciesId }})
      })
    }
  },
  created() {
    this.popupResultActivo = true;
  }
};
</script>

<style scoped></style>
